import { Link } from 'react-router';

const HowTos = () => (
  <div className="bg-white rounded-lg shadow-sm border p-4">
    <div className="font-bold text-lg mb-2">Tutorials</div>
    <ul>
      <li className="text-sm mt-4">
        <Link
          to="https://docs.sesame.software/essentials/getting-started.html#creating-a-pathway"
          target="_blank"
          className="text-info link-hover"
        >
          Creating a Pathway
        </Link>
      </li>
      <li className="text-sm mt-4">
        <Link
          to="https://docs.sesame.software/essentials/getting-started.html#changing-pathway-parameters"
          target="_blank"
          className="text-info link-hover"
        >
          Changing Pathway Parameters
        </Link>
      </li>
      <li className="text-sm mt-4">
        <Link
          to="https://docs.sesame.software/essentials/getting-started.html#running-a-pathway"
          target="_blank"
          className="text-info link-hover"
        >
          Running a Pathway
        </Link>
      </li>
      <li className="text-sm mt-4">
        <Link
          to="https://docs.sesame.software/essentials/getting-started.html#visualizing-results"
          target="_blank"
          className="text-info link-hover"
        >
          Visualizing Results
        </Link>
      </li>
      <li className="text-sm mt-4">
        <Link
          to="https://docs.sesame.software/essentials/getting-started.html#comparison-of-multiple-pathways"
          target="_blank"
          className="text-info link-hover"
        >
          Comparison of Multiple Pathways
        </Link>
      </li>
    </ul>
  </div>
);

export default HowTos;
